<ng-container *ngIf="mode() === dialogModes.LOADING">
  <q9-content-loader [isLoading]="true"></q9-content-loader>
</ng-container>

<ng-container *ngIf="mode() === dialogModes.ADD">
  <div mat-dialog-title>
    <span>{{ 'CORE.RESOURCES.ATTACH_RESOURCE' | translate }}</span>
    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <q9-info-message *ngIf="error()" type="error">
    {{ error() | translate }}
  </q9-info-message>

  <mat-dialog-content class="content">
    <div class="search-box">
      <q9-text-field
        [label]="'CORE.RESOURCES.QUICK_SEARCH'"
        [formControl]="nameFilterFormControl"></q9-text-field>

      <q9-select [label]="'CORE.RESOURCES.LABEL_TYPE'" [formControl]="filterTypeFormControl">
        <q9-option *ngFor="let type of resourcesTypes" [value]="type">
          {{ type | displayResource }}
        </q9-option>
      </q9-select>

      <q9-select
        [label]="'CORE.RESOURCES.LABEL_RESOURCE_SOURCE'"
        [formControl]="filterSystemFormControl">
        <q9-option *ngFor="let system of systems" [value]="system">
          {{ system | displaySystem }}
        </q9-option>
      </q9-select>
    </div>

    <ng-container *ngIf="filteredResources() as filtered">
      <cdk-virtual-scroll-viewport
        *ngIf="filtered.length"
        class="selection-list"
        role="listbox"
        aria-multiselectable="true"
        tabindex="0"
        [attr.aria-activedescendant]="activeId()"
        (focus)="onListFocus(filtered)"
        (blur)="onListBlur()"
        (keydown)="onListKeydown($event, filtered)"
        [itemSize]="ROW_HEIGHT">
        <div
          *cdkVirtualFor="let res of filtered; let i = index; trackBy: trackByRef"
          class="resource-option"
          role="option"
          [id]="optionId(i)"
          [attr.aria-selected]="isSelected(res)"
          [attr.aria-disabled]="isOptionDisabled(res, resourceVM()) ? 'true' : null"
          [class.resource-option--selected]="isSelected(res)"
          [class.resource-option--active]="i === activeIndex()"
          [class.resource-option--disabled]="isOptionDisabled(res, resourceVM())"
          (click)="onOptionClick(i, res)">
          <mat-pseudo-checkbox
            class="resource-option__check"
            [state]="isSelected(res) ? 'checked' : 'unchecked'"
            [disabled]="isOptionDisabled(res, resourceVM())"></mat-pseudo-checkbox>
          <div class="option-container">
            <ng-container *ngIf="!res.icon; else icon">
              <div class="no-icon">
                <span class="no-icon--symbol">{{ res.name?.charAt(0) }}</span>
              </div>
            </ng-container>
            <ng-template #icon>
              <div class="res-icon">
                <img
                  class="res-icon--img"
                  [src]="res.icon"
                  [alt]="res.name"
                  loading="lazy"
                  decoding="async" />
              </div>
            </ng-template>
            <span class="res-name">{{ res.name | decodeHtml }}</span>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>

      <div *ngIf="!filtered.length" class="selection-list empty-state">
        <img [src]="noResourcesImage" [alt]="'POPUPS.NOT_FOUND' | translate" />
        <span>{{ 'POPUPS.NOT_FOUND' | translate }}</span>
      </div>
    </ng-container>

    <mat-slide-toggle
      *ngIf="data.isPro && !isArchitectural"
      [checked]="!attachHidden"
      (change)="changeHiddenFlag(!$event.checked)">
      {{ 'CORE.RESOURCES.VISIBLE_RESOURCE' | translate }}
    </mat-slide-toggle>

    <mat-slide-toggle
      *ngIf="isArchitectural"
      [disabled]="selected().length > 1"
      (change)="choosingMainToggle($event.checked)">
      {{ 'CORE.RESOURCES.MAIN_ON_CARD_LABEL' | translate }}
    </mat-slide-toggle>
  </mat-dialog-content>

  <mat-dialog-actions>
    <q9-link-button class="create-resource-btn" (click)="mode.set(dialogModes.CREATE)">
      {{ 'CORE.RESOURCES.SWITCH_CREATE' | translate }}
    </q9-link-button>

    <q9-secondary-button mat-dialog-close>
      {{ 'CORE.RESOURCES.CANCEL' | translate }}
    </q9-secondary-button>

    <q9-primary-button (click)="addResource()">
      {{ 'CORE.RESOURCES.ADD' | translate }}
    </q9-primary-button>
  </mat-dialog-actions>
</ng-container>

<app-create-resource-dialog
  *ngIf="mode() === dialogModes.CREATE"
  [name]="nameFilterFormControl.value"
  [data]="data"
  [isArchitectural]="isArchitectural"
  [attachHidden]="attachHidden"
  [canSwitchToList]="!!all().length"
  (changeHiddenFlag)="changeHiddenFlag($event)"
  (switchCreateMode)="mode.set(dialogModes.ADD)"></app-create-resource-dialog>
